{
  "title": "Decompose (HB)",
  "source": "Critical Role (Twitter)",
  "levelAndSchool": "Necromancy cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "1 minute",
  "description": [
    "You reach out and touch the corpse of a creature. Over the next minute, the corpse begins to rapidly decompose, sprouting fungus and moss as it begins to degrade into compost and mulch. An odd-colored flower or two may also spring from the corpse in this time. Applicable requirements for resurrection are unaffected by this decomposition."
  ],
  "spellLists": ["cleric"]
}
